


























import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
const cssPrefix = 'item-content';

@Component({
  components: {
    SwCheckbox,
  },
})
export default class ItemContent extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  selectedItems: any = [];
  // @Prop({ type: Array })
  // selectedList: any;

  @Prop({ type: String })
  checkBoxName: string;

  @Prop({ type: String })
  checkBoxValue: string;

  onSelectItem() {
    this.$emit('on-select', this.selectedItems);
  }

  created() {
    // this.selectedItems = this.selectedList;
  }
}
